export default __webpack_public_path__ + "static/media/DNo.36-0.ef075983.jpg";